/**
 * Login page - redirects to Scalekit OAuth login
 */
import React, { useState } from 'react';
import { Loader2 } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useAuthStore } from '@/store/authStore';

export const Login: React.FC = () => {
  const [error, setError] = useState('');
  const { redirectToLogin, isLoading } = useAuthStore();

  const handleLogin = async () => {
    try {
      await redirectToLogin();
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Failed to redirect to login';
      setError(message);
    }
  };

  return (
    <div className="mx-auto flex min-h-screen max-w-sm flex-col items-center justify-center p-4">
      <Card className="w-full">
        <CardContent className="pt-6">
          <h1 className="mb-2 text-center text-2xl font-semibold">Voucher Tracker</h1>
          <p className="mb-6 text-center text-sm text-muted-foreground">
            Manage your gift vouchers in one place
          </p>

          <div className="mb-4 mt-6 text-center">
            <Button
              className="h-12 w-full"
              size="lg"
              onClick={handleLogin}
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <Loader2 className="mr-2 size-5 animate-spin" />
                  Redirecting...
                </>
              ) : (
                'Sign In with Scalekit'
              )}
            </Button>
          </div>

          {error && (
            <p className="mt-4 text-center text-sm text-destructive">{error}</p>
          )}
          <p className="mt-4 block text-center text-xs text-muted-foreground">
            You will be redirected to Scalekit to sign in securely
          </p>
        </CardContent>
      </Card>
    </div>
  );
};
